import React, { useEffect, useState } from "react";
import Input from "../../components/Input";
import "./styles.scss";
import { ReactComponent as IconSearch } from "../../assets/icons/icon-search.svg";
import { useAtom } from "jotai";
import { userAtom } from "../../state/auth";
import { refreshAtomClients } from "../../state/refreshClientsList";
import Button from "../../components/ButtonUI";
import Spinner from "../../components/Spinner";
import { getAllClients, syncronizeClient } from "../../api/client";
import CardClient from "./CardClient";
import AddClient from "./CardClient/addClient";
import PaginationClients from "../../components/paginatedClients";
import makeToast from "../../components/Snackbar";

interface IClient {
  _id: string;
  name: string;
}

const generateState = () => {
  return Math.random().toString(36).substring(2, 15);
};


const Contributeurs: React.FC = () => {
  const [search, setSearch] = useState(false);
  const [user] = useAtom(userAtom);
  const [loading, setLoading] = useState(false);
  const [totalResult, setTotalResult] = useState(0);
  const [data, dataSet] = useState<any>([]);

  const [modalAdd, setModalAdd] = useState(false);
  const [modal, setModal] = useState(false);
  const [refresh, setRefresh] = useAtom(refreshAtomClients);

  const [listClients, setListClients] = useState<IClient[]>([]);
  const [selectedClient, setSelectedClient] = useState("");
  const [clientData, setClientData] = useState<IClient>();
  const [isResponsable, setIsResponsable] = useState(
    user?.type === "medecinResponsable" ? true : false
  );
  const [clientAdded, setClientAdded] = useState(false);
  const [filteredData, setFilteredData] = useState<IClient[]>([]);
  const [strFilter, setStrFilter] = useState<string>("");
  const [syncLoading, setSyncLoading] = useState(false);

  const syncronizeClientList = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const error = urlParams.get('error');

    if (error) {
      makeToast("error", `Erreur d'authentification: ${error}`);
      window.history.replaceState({}, document.title, window.location.pathname);
      return;
    }

    if (!code) {
      console.log("No code found, redirecting to Qonto for authentication...");
      const CLIENT_ID = "f4eff4db-1b72-4a85-b4f7-9c0eddffdd88"; 
      const REDIRECT_URI = encodeURIComponent("https://avisdoc.katomi.co/journeesdepistage/contributeurs");
      const state = generateState();
      
      window.location.href = `https://oauth.qonto.com/oauth2/auth?client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=client.read&state=${state}`;
      return;
    }

    try {
      setSyncLoading(true);
      await syncronizeClient(code);
      makeToast("success", "Connexion à Qonto réussie !");
      
      window.history.replaceState({}, document.title, window.location.pathname);
      fetchMyData();
    } catch (e) {
      makeToast("error", "Échec de l'échange de jeton");
    } finally {
      setSyncLoading(false);
    }
  };

  const fetchMyData = async () => {
    setLoading(true);
    let apiResult = await getAllClients();
    const clientsArray = Array.isArray(apiResult?.response)
    ? apiResult.response
    : [];
    setListClients(clientsArray);
    dataSet(clientsArray);

    setLoading(false);
  };
  const fetchMyDataOnly = async () => {
    const apiResult = await getAllClients();
    const clientsArray = Array.isArray(apiResult?.response)
      ? apiResult.response
      : [];
    setListClients(clientsArray);
    dataSet(clientsArray);
  };

  useEffect(() => {
    if (strFilter === "") {
      setFilteredData(listClients);
    } else {
      setFilteredData(
        listClients.filter((c) =>
          c.name.toLowerCase().includes(strFilter.toLowerCase())
        )
      );
    }
  }, [listClients, strFilter]);

  useEffect(() => {
    fetchMyData();
  }, [refresh]);

  /*useEffect(() => {
    const init = async () => {
      try {
        setLoading(true);

        const res =await syncronizeClient();
        //console.log("Initial sync result:", res);
        
        if(res=== undefined){
          makeToast(
          "error",
          `Erreur lors de la synchronisation automatique`
          );
        }
        await fetchMyDataOnly();

      } catch (error: any) {
        console.log("Init sync error:", error);

        makeToast(
          "error",
          `Erreur lors de la synchronisation automatique`
        );

      } finally {
        setLoading(false);
      }
    };

    init();
  }, []);*/

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get('code');
    if (code) {
      syncronizeClientList();
    }
  }, []);
  return loading ? (
    <Spinner />
  ) : (
    <>
      <div className="mx-16 my-patients">
        <header className="flex justify-between items-center w-full flex-wrap">
          <div className="title-container">
            <h1 className="pageTitle">Gestion des Clients</h1>
          </div>
          <div className="flex max-w-max items-center space-x-2 ">
            <div className="relative">
              <Button
                status="secondary"
                onClick={syncLoading ? undefined : syncronizeClientList}
                className={`
                  btnAddPatient
                  relative
                  transition-all
                  duration-300
                  ${syncLoading 
                    ? "opacity-80 cursor-not-allowed bg-blue-400" 
                    : "hover:scale-105 hover:shadow-lg"}
                `}
              >
                <span className={syncLoading ? "opacity-0" : "opacity-100"}>
                  Synchroniser les clients
                </span>

                {syncLoading && (
                  <span className="absolute inset-0 flex items-center justify-center">
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8H4z"
                      />
                    </svg>
                  </span>
                )}
              </Button>
            </div>
          </div>
        </header>

        <div className="flex justify-between items-center w-full mt-5 filtres">
          <div className="relative flex w-full flex-wrap  mb-3 mx-6 mt-2 ">
            <span className="z-10 h-full leading-snug font-normal  text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-1 py-1">
              <IconSearch />
            </span>
            <Input
              type="text"
              placeholder="Rechercher par : nom"
              style={{ width: 361 }}
              onChange={(e) => setStrFilter(e.target.value)}
              onKeyPress={(event) => {}}
              className="rounded-xl px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white  text-sm outline-none focus:border-blue-500  border-blue-100 h-12 w-full pl-10"
            />

            <div className="flex">
              
            </div>
          </div>

          {totalResult && search ? (
            <div>{totalResult} résultats trouvés</div>
          ) : (
            ""
          )}
        </div>

        <div className={`patient-list flex flex-wrap justify-between w-full"`}>
          {listClients.length !== 0 ? (
            <PaginationClients
              key={listClients.length}
              data={
                //isResponsable
                   strFilter === ""
                    ? listClients
                    : filteredData
                  //: strFilter === ""
                  //? user?.patients
                  //: filteredData
              }
              RenderComponent={CardClient}
              pageLimit={50}
              Pages={() => {
                  return Math.ceil(
                    strFilter === ""
                      ? listClients.length / 10
                      : filteredData.length / 10
                  );
                
              }}
              dataLimit={10}
              modal={modal}
              setModal={setModal}
              setSelectedClient={setSelectedClient}
              selectedClient={selectedClient}
              setPages={strFilter === ""}
              setModalAdd={setModalAdd}
              setClientData={setClientData}
              setRefreshClient={setRefresh}
            ></PaginationClients>
          ) : (
            <div className="w-full flexCenter mt-24">
              <h3>Aucun client trouvé</h3>
            </div>
          )}
        </div>

        {modalAdd && (
          <AddClient
            openModal={modalAdd}
            setOpenModal={setModalAdd}
            setClientAdded={setClientAdded}
            setSelectedClient={setSelectedClient}
            setClientData={setClientData}
            setOpenModalInfoClient={setModal}
            editMode={!!clientData?._id}
            clientData={clientData || { _id: "", name: "" }}
            setRefreshClient={setRefresh}
          />
        )}

      </div>
    </>
  );
};

export default Contributeurs;
